// libs
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

function CardInfo(props, { t }) {
  const { title, subtitle } = props;
  return (
    <div className="card__info">
      <h1 className="card__titles">
        <span className="card__title" dangerouslySetInnerHTML={{ __html: title }} />
        {subtitle &&
          <Fragment>
            <span className="card__titles__spacer"> {t('pages.site.separator')} </span>
            <span className="card__subtitle">
              {subtitle}
            </span>
          </Fragment>
        }
      </h1>
    </div>
  );
}


CardInfo.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

CardInfo.defaultProps = {
  subtitle: null,
};

CardInfo.contextTypes = {
  t: PropTypes.func,
};

export default CardInfo;



// WEBPACK FOOTER //
// ./src/app/components/cards/card/parts/CardInfo.js